import { FeedstockKey, MetricKey } from '../types/emission-factor.constants';
import { useCallback } from 'react';
import { useEmissionFactorRecord } from './useEmissionFactorRecord';
import { useHierarchyNavigation } from './useHierarchyNavigation';

export function useEmissionFactorModal(materialGradeId?: string) {
   const hierarchy = useHierarchyNavigation(materialGradeId);
   const { setFormState, cachedResponsesRef, formState } = hierarchy;

   const onChangesFlushed = useCallback(() => {
      setFormState((prev) => ({ ...prev, hasChanges: false }));
   }, [setFormState]);

   const record = useEmissionFactorRecord(formState.selectedGrade, cachedResponsesRef, onChangesFlushed);
   const { updateYearlyValue: recordUpdateYearlyValue, addYear: recordAddYear, removeYear: recordRemoveYear } = record;

   const updateYearlyValue = useCallback(
      (year: number, feedstock: FeedstockKey, field: MetricKey, value: number | null) => {
         recordUpdateYearlyValue(year, feedstock, field, value);
         setFormState((prev) => ({ ...prev, hasChanges: true }));
      },
      [recordUpdateYearlyValue, setFormState]
   );

   const addYear = useCallback(
      (year: number) => {
         const didAdd = recordAddYear(year);
         if (didAdd) {
            setFormState((prev) => ({ ...prev, hasChanges: true }));
         }
         return didAdd;
      },
      [recordAddYear, setFormState]
   );

   const removeYear = useCallback(
      (year: number) => {
         recordRemoveYear(year);
         setFormState((prev) => ({ ...prev, hasChanges: true }));
      },
      [recordRemoveYear, setFormState]
   );

   return {
      ...hierarchy,
      ...record,
      updateYearlyValue,
      addYear,
      removeYear,
      error: hierarchy.error || record.saveError,
   };
}
